import { render, staticRenderFns } from "./floorRecord.vue?vue&type=template&id=2647074c&scoped=true"
import script from "./floorRecord.vue?vue&type=script&lang=js"
export * from "./floorRecord.vue?vue&type=script&lang=js"
import style0 from "./floorRecord.vue?vue&type=style&index=0&id=2647074c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647074c",
  null
  
)

export default component.exports